import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../components/commons";
import { RootState } from "../../redux/rootReducers";
import {
  GetAllFinacUserPayloadType,
} from "../../commonTypes/authTypes";
import {
  getAllFinacGovtOfficerAction,
  resetAuthError,
  resetAuthSuccess,
  resetFinacGovtOfficerList,
  resetSession,
  resetTotalGovtOfficerCount,
  userProfileAction,
} from "../../redux/auth";
import { connect } from "react-redux";
import { SearchIcon } from "../../components/Icon";
import { EmptyList } from "../../assets/images";
import useDebounce from "../../customHooks/useDebounce";
import GovermentDirectoryTable from "../../components/GovermentDirectory/GovermentDirectoryTable";
import { FinacUsersType, UserProfileType } from "../../redux/auth/authTypes";
import ViewTeamDirectoryDetails from "../../components/TeamDirectory/ViewTeamDirectoryDetails";

type AppProps = {
  fetching: boolean;
  token: string | null;
  history: any;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  dispatchResetSession: () => void;
  dispatchResetError: () => void;
  dispatchResetAuthSuccess: () => void;
  totalUserCount: string | number;
  dispatchResetTotalUserCount: () => void;
  dispatchResetGovtOfficerList: () => void;
  dispatchGetAllFinacGovtOfficerAction: (
    data: GetAllFinacUserPayloadType
  ) => void;
  govtOfficerList: [] | FinacUsersType[];
  userProfileAllData: UserProfileType;
  dispatchUserProfileData: (data: any) => void;
};
const GovermentDirectory = ({
  fetching,
  token,
  history,
  success,
  error,
  statusCode,
  totalUserCount,
  govtOfficerList,
  userProfileAllData,
  dispatchResetSession,
  dispatchResetError,
  dispatchResetAuthSuccess,
  dispatchResetTotalUserCount,
  dispatchResetGovtOfficerList,
  dispatchGetAllFinacGovtOfficerAction,
  dispatchUserProfileData,
}: AppProps) => {
  const [userOffset, setUserOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [userData, setUserData] = useState<any>([]);
  const [userSearchData, setUserSearchData] = useState<string>("");
  const [userSearchClear, setUserSearchClear] = useState(false);
  const [loadCondition, setLoadCondition] = useState<boolean>(true);
  const [showOfficerDetails, setShowOfficerDetails] = useState<boolean>(false);
  
  useEffect(() => {
    setUserData([]);
    window.scroll({
      top: 0,
      left: 0,
    });
    dispatchResetAuthSuccess();
    dispatchResetError();
    // dispatchResetUserDetails();
    dispatchResetGovtOfficerList();
    dispatchResetTotalUserCount();
    if (userOffset > 0) {
      setUserOffset(0);
    }
  }, []);

  useEffect(() => {
    if (govtOfficerList?.length === 0) {
      setUserData(govtOfficerList);
    } else if (userOffset > 0 && userData?.length > 0) {
      setUserData((prv: any) => [...prv, ...govtOfficerList]);
    } else {
      setUserData(govtOfficerList);
    }
  }, [govtOfficerList]);

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        limit,
        offset: userOffset,
        search_term: userSearchData,
        user_type: "govt_officer",
        status: 1,
      };

      if (totalUserCount) {
        if (+totalUserCount > userOffset) {
          dispatchGetAllFinacGovtOfficerAction(finalData);
        }
      } else {
        dispatchGetAllFinacGovtOfficerAction(finalData);
      }
    }
  }, [userOffset]);


  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        !fetching &&
        userOffset < +totalUserCount &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (govtOfficerList?.length > 0) {
          if (!fetching && userOffset < +totalUserCount) {
            setUserOffset(userOffset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (userSearchClear) {
      let finalData = {
        token,
        limit,
        offset: userOffset,
        search_term: userSearchData,
        user_type: "govt_officer",
        status: 1,
      };
      if (userSearchData?.length === 0) {
        // dispatchResetUserDetails();
        dispatchResetGovtOfficerList();
        dispatchGetAllFinacGovtOfficerAction(finalData);
        setUserOffset(0);
      }
    }
  }, [userSearchClear, userSearchData]);

  useDebounce(
    () => {
      if (userSearchData) {
        fetchNewData();
      }
    },
    500,
    [userSearchData]
  );

  const fetchNewData = () => {
    setUserData([]);
    // dispatchResetUserDetails();
    dispatchResetGovtOfficerList();
    dispatchResetTotalUserCount();
    let finalData = {
      token,
      limit,
      offset: userOffset,
      search_term: userSearchData,
      user_type: "govt_officer",
      status: 1,
    };
    if (token) {
      setUserSearchClear(true);

      if (userOffset === 0) {
        dispatchGetAllFinacGovtOfficerAction(finalData);
        setUserOffset(0);
      } else {
        setUserOffset(0);
      }
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [govtOfficerList]);

  const toggleOfficerDetails = () => {
    setShowOfficerDetails(false);
  };
  const handleShowUserDetails = (data: any) => {
    if (token) {
      let final_data = {
        token,
        user_id: data?.user_id,
      };
      dispatchUserProfileData(final_data);
    }
    setShowOfficerDetails(true);
  };
  const handleSearchUser = (e: any) => {
    setUserSearchData(e.target.value);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <div className="row">
      <div className="col-md-6">
        <CommonHeader title="Officer's Directory" />
      </div>
      <div className="col-md-12">
        <div className="jobs-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">Officer's Directory List</div>
              {!fetching && (
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  totalUserCount ? totalUserCount : 0
                } users found`}</div>
              )}
            </div>
            <div className="right-header">
              <div className={"col-md-10 position-relative"}>
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e: any) => handleSearchUser(e)}
                  style={{ paddingLeft: "35px" }}
                  value={userSearchData}
                />
              </div>
            </div>
          </div>
          <div>
            {fetching && userOffset == 0 && !showOfficerDetails ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : userData?.length > 0 ? (
              <GovermentDirectoryTable
                data={userData}
                fetching={fetching}
                offset={userOffset}
                history={history}
                token={token}
                handleShowUserDetails={handleShowUserDetails}
              />
            ) : (
              <div className="mt-5 pb-5">
                {!fetching && userData?.length === 0 && (
                  <EmptyListPage
                    title="No Data Found!"
                    image={EmptyList}
                    imageWidth="30%"
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>

    {showOfficerDetails && (
      <ViewTeamDirectoryDetails
        isRight={true}
        isOpen={showOfficerDetails}
        onClose={toggleOfficerDetails}
        userProfileAllData={userProfileAllData}
        fetching={fetching}
        />
    )}

      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  fetching: state.auth.fetching,
  success: state.auth.success,
  error: state.auth.error,
  statusCode: state.auth.statusCode,
  token: state.auth.token,
  userProfileAllData: state.auth.userProfileAllData,
  totalUserCount: state.auth.totalGovtOfficerCount,
  govtOfficerList: state.auth.finacGovtOfficerList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllFinacGovtOfficerAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacGovtOfficerAction(data)),
  dispatchResetError: () => dispatch(resetAuthError()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchUserProfileData: (data: any) => dispatch(userProfileAction(data)),
  dispatchResetGovtOfficerList: () => dispatch(resetFinacGovtOfficerList()),
  dispatchResetTotalUserCount: () => dispatch(resetTotalGovtOfficerCount()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GovermentDirectory);
